<template>
	<div class="star">
		<ul class="star-items" v-if="currentNum">
			<li class="star-item star-item-active" v-for="index in currentNum" @click="getIndex"></li>
			<li class="star-item" v-for="index in 5-currentNum" @click="getIndex"></li>
		</ul>
	</div>
</template>

<script>
	export default{
		props:["num","canSlide"],
		data(){
			return{
				currentNum:this.num
			}
		},
		mounted(){
			
		},
		methods:{
			getIndex(evt){
				if(this.canSlide){
					document.querySelectorAll(".star-item").forEach((value,index)=>{
						if(evt.target==value){//获取到点击的星星的index
							index+=1;
							if(index!=this.currentNum){
								console.log(index)
								this.currentNum=index;
								this.$emit("change",index);
							}
						}
					});
				}
			}
		},
		watch:{
			num(){
				this.currentNum=this.num;
			}
		}
	}
</script>

<style>
	.star-items{
		font-size: 0;
	}
	.star-item{
		display: inline-block;
		width:0.293rem;
		height:0.266rem;
		margin:0 0.026rem;
		background:url(../lesson-detail/star.png) center center no-repeat;
		background-size: 0.293rem;
	}
	.star-item-active{
		background-image: url(../lesson-detail/star-light.png);
	}
</style>


// WEBPACK FOOTER //
// src/components/star/star.vue